<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20 2H4C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2Z"
      fill="#D5D8DC"
    />
    <path
      d="M16.2001 5.44348C16.0156 5.44305 15.8383 5.51483 15.7061 5.64348L14.4141 6.94348L17.0601 9.58948L18.3511 8.29848C18.4168 8.23339 18.469 8.1559 18.5047 8.07051C18.5403 7.98512 18.5586 7.89351 18.5586 7.80098C18.5586 7.70845 18.5403 7.61684 18.5047 7.53145C18.469 7.44605 18.4168 7.36857 18.3511 7.30348L16.7011 5.64348C16.6353 5.57846 16.5572 5.52727 16.4713 5.49293C16.3854 5.45858 16.2935 5.44176 16.2011 5.44348H16.2001Z"
      fill="#363C43"
    />
    <path
      d="M13.2453 8.10156L5.44531 15.9066V18.5526H8.09131L15.8913 10.7526L13.2453 8.10156Z"
      fill="#3CB149"
    />
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
